var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',{style:(_vm.style),attrs:{"width":735 - _vm.borderWidth,"height":1215 - _vm.borderWidth,"x":_vm.offset,"y":_vm.offset,"ry":_vm.radius,"rx":_vm.radius,"fill":_vm.backgroundColor}})}
var staticRenderFns = []

export { render, staticRenderFns }